import React from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import styled from 'styled-components'
import Image from 'react-bootstrap/Image'
import TMDMBlack from '../images/TMDMBlack.png'


const StyledJumbotron = styled(Jumbotron)`
    color: black;
    background: white;
    margin-bottom: 0px;
    align-items: center;
    text-align: left;
    position: relative;
    overflow: hidden;
    padding: 1rem;

`
const StyledLine = styled.hr`
    margin-bottom: 1.7rem;
    height: 1px;
    border: 0;
    box-shadow: 0 1px 1px -1px #8c8c8c inset;
`

const MainTitle = styled.h1`
    margin:0 auto;
    font-size: calc(12px + 1vw);
    padding-bottom: 0;
    font-weight: bold;
       
`
const MainCaption = styled.h1`
    margin: 0 auto;
    font-size: calc(12px + 0.8vw);
    padding-bottom: 0;
    font-weight: normal;
`
const MainCopyright = styled.h1`
    margin: 0 auto;
    font-size: 0.7vw;
    padding-bottom: 0;
    font-weight: normal;
`

const TmdLogoImageWrapper = styled(Container)`
    border:0;
    position:relative; 
    top:0%;
    margin-left: 0%;
`

const Footer = ({address, phone, copyright, title}) => {
    return (
        <StyledJumbotron fluid>
            <StyledLine></StyledLine>
            <Row>
                <Col sm={1} xs={6} style={{"paddingRight": "0" }}>
                    <TmdLogoImageWrapper>
                        <a href = 'https://www.michigandaily.com/'>
                        <Image src={TMDMBlack} fluid/>
                        </a>
                    </TmdLogoImageWrapper>
                </Col>
                <Col sm={11} xs={6} >
                    <Container style={{ "marginLeft" : "0", "marginRight" : "0", "padding": "0", "marginBottom": "0"}}>
                        <MainTitle>{title}</MainTitle>
                        <MainCaption>{address}</MainCaption>
                        <MainCaption>{phone}</MainCaption>
                    </Container>
                </Col>
            </Row>
            <Row style={{"marginBottom": "0", "marginTop": "1rem" }}>
                <MainCopyright>{copyright}</MainCopyright>
            </Row>
            
                                  
            
        </StyledJumbotron>
    );
}

export default Footer;